/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import * as Urql from 'urql';

import type * as Types from '../../../../../../../../generated/graphql/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SpDataByQueryFragment = {
  __typename?: 'SProductsQuery';
  listByQuery?: {
    __typename?: 'SProductList';
    positions?: Array<number>;
    isFirstMF: boolean;
    products: Array<{
      __typename?: 'SProduct';
      adPayer: Types.AdPayer;
      adTrackingData: string;
      mgr?: number;
      channelOffer?: { __typename?: 'ChannelOffer'; productId: string };
    }>;
  };
};

export type SpDataSearchBarQueryVariables = Types.Exact<{
  context: Types.SContentContext;
  query: Types.Scalars['String']['input'];
  filters?: Types.InputMaybe<Types.SProductFilters>;
}>;

export type SpDataSearchBarQuery = {
  __typename?: 'Query';
  sProducts?: {
    __typename?: 'SProductsQuery';
    listByQuery?: {
      __typename?: 'SProductList';
      positions?: Array<number>;
      isFirstMF: boolean;
      products: Array<{
        __typename?: 'SProduct';
        adPayer: Types.AdPayer;
        adTrackingData: string;
        mgr?: number;
        channelOffer?: { __typename?: 'ChannelOffer'; productId: string };
      }>;
    };
  };
};

export type SpDataSearchPageQueryVariables = Types.Exact<{
  context: Types.SContentContext;
  query: Types.Scalars['String']['input'];
  filters?: Types.InputMaybe<Types.SProductFilters>;
}>;

export type SpDataSearchPageQuery = {
  __typename?: 'Query';
  sProducts?: {
    __typename?: 'SProductsQuery';
    listByQuery?: {
      __typename?: 'SProductList';
      positions?: Array<number>;
      isFirstMF: boolean;
      products: Array<{
        __typename?: 'SProduct';
        adPayer: Types.AdPayer;
        adTrackingData: string;
        mgr?: number;
        channelOffer?: { __typename?: 'ChannelOffer'; productId: string };
      }>;
    };
  };
};

export type SpDataMassLandingPageQueryVariables = Types.Exact<{
  context: Types.SContentContext;
  query: Types.Scalars['String']['input'];
  filters?: Types.InputMaybe<Types.SProductFilters>;
}>;

export type SpDataMassLandingPageQuery = {
  __typename?: 'Query';
  sProducts?: {
    __typename?: 'SProductsQuery';
    listByQuery?: {
      __typename?: 'SProductList';
      positions?: Array<number>;
      isFirstMF: boolean;
      products: Array<{
        __typename?: 'SProduct';
        adPayer: Types.AdPayer;
        adTrackingData: string;
        mgr?: number;
        channelOffer?: { __typename?: 'ChannelOffer'; productId: string };
      }>;
    };
  };
};

export const SpDataByQueryFragmentDoc = /*#__PURE__*/ `
    fragment SpDataByQuery on SProductsQuery {
  listByQuery(context: $context, query: $query, filters: $filters) {
    products {
      adPayer
      adTrackingData
      mgr
      channelOffer {
        productId
      }
    }
    positions
    isFirstMF
  }
}
    `;
export const SpDataSearchBarDocument = /*#__PURE__*/ `
    query SpDataSearchBar($context: SContentContext!, $query: String!, $filters: SProductFilters) {
  sProducts: sProducts {
    ...SpDataByQuery
  }
}
    ${SpDataByQueryFragmentDoc}`;

export function useSpDataSearchBarQuery(
  options: Omit<Urql.UseQueryArgs<SpDataSearchBarQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SpDataSearchBarQuery, SpDataSearchBarQueryVariables>({
    query: SpDataSearchBarDocument,
    ...options,
  });
}
export const SpDataSearchPageDocument = /*#__PURE__*/ `
    query SpDataSearchPage($context: SContentContext!, $query: String!, $filters: SProductFilters) {
  sProducts: sProducts {
    ...SpDataByQuery
  }
}
    ${SpDataByQueryFragmentDoc}`;

export function useSpDataSearchPageQuery(
  options: Omit<Urql.UseQueryArgs<SpDataSearchPageQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SpDataSearchPageQuery, SpDataSearchPageQueryVariables>({
    query: SpDataSearchPageDocument,
    ...options,
  });
}
export const SpDataMassLandingPageDocument = /*#__PURE__*/ `
    query SpDataMassLandingPage($context: SContentContext!, $query: String!, $filters: SProductFilters) {
  sProducts: sProducts {
    ...SpDataByQuery
  }
}
    ${SpDataByQueryFragmentDoc}`;

export function useSpDataMassLandingPageQuery(
  options: Omit<
    Urql.UseQueryArgs<SpDataMassLandingPageQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    SpDataMassLandingPageQuery,
    SpDataMassLandingPageQueryVariables
  >({ query: SpDataMassLandingPageDocument, ...options });
}
